module.exports = __webpack_public_path__ + "img/viscous_ooze_slime_trail.2a007538.png";